import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useUtilizationCardStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalL,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    minWidth: '14rem',
  },
  header: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
  },
  label: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  percentage: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorBrandForeground1,
  },
  notApplicable: {
    color: tokens.colorNeutralForeground3,
  },
  caption: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
  },
  detail: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground2,
  },
});
